import {
	DATA_SEARCH_WAS_REQUESTED,
	DATA_WAS_REQUESTED,
	EXPORT_FINISHED,
	EXPORT_FINISHED_MODAL,
	EXPORT_WAS_REQUESTED,
	SALES_FILTERED,
	SALES_FIND_ERROR,
	SALES_HAS_FIELD_ERRORS,
	SALES_OPEN_CLOSE_EXPORT_MODAL,
	SALES_OPEN_CLOSE_FILTER_MODAL,
	SALES_OPEN_CLOSE_SEARCH_MOBILE,
	SALES_RECEIVED,
	SALES_SEARCH_IS_OPEN,
	SALES_SEARCH_NOT_FOUND,
	SALES_SEARCH_RECEIVED,
	SALES_TAB_STATUS_FILTERED,
	SALES_VIEW_MODE,
	EXPORT_IRPF_REQUESTED,
	EXPORT_IRPF_FINISH,
	OPEN_CLOSE_GENERAL_ALERT,
	EXPORT_DOCS_FINISHED
} from "../shared/constants";
import {
	exportOffer,
	getUserSaleByTicket,
	getUserSalesByPeriod,
	exportToDownloadOffer,
	exportIRPFToDownloadOffer
} from "../shared/requests-api";
import { getUserToken } from "../shared/utils";

export function getAllSales(filters, modalOppened) {
	return function(dispatch) {
		dispatch({
			type: DATA_WAS_REQUESTED
		});

		if (modalOppened) {
			dispatch({
				type: SALES_OPEN_CLOSE_FILTER_MODAL,
				payload: false
			});
		}

		const {
			token,
			start,
			end,
			periodType,
			idsFidelity,
			status,
			numPag,
			salesPerPage,
			modality
		} = filters;

		getUserSalesByPeriod({
			token,
			start,
			end,
			periodType,
			idsFidelity,
			status,
			modality,
			salesPerPage,
			numPag
		})
			.then(success => {
				dispatch({
					type: SALES_SEARCH_NOT_FOUND,
					payload: success.data.sales.length <= 0
				});
				dispatch({
					type: SALES_RECEIVED,
					payload: success
				});
			})
			.catch(error => {
				dispatch({
					type: SALES_FIND_ERROR,
					payload: error
				});
			});
	};
}

export function exportSales(filters) {
	return function(dispatch) {
		dispatch({
			type: EXPORT_WAS_REQUESTED,
			payload: true
		});

		const { token, start, end, periodType, idsFidelity, sendToEmail, checkboxStatus } = filters;

		exportOffer({ token, start, end, periodType, idsFidelity, sendToEmail, ...checkboxStatus })
			.then(result => {
				dispatch({
					type: EXPORT_FINISHED
				});
			})
			.catch(() => {
				dispatch({
					type: EXPORT_WAS_REQUESTED,
					payload: false
				});
			});
	};
}

export function exportToDownloadSales(filters) {
	return function(dispatch) {
		dispatch({
			type: EXPORT_WAS_REQUESTED,
			payload: true
		});

		const { token, start, end, periodType, idsFidelity, checkboxStatus, fileType } = filters;

		exportToDownloadOffer({
			token,
			start,
			end,
			periodType,
			idsFidelity,
			...checkboxStatus,
			fileType
		})
			.then(result => {
				dispatch({
					type: EXPORT_DOCS_FINISHED
				});
			})
			.catch(() => {
				dispatch({
					type: EXPORT_WAS_REQUESTED,
					payload: false
				});
			});
	};
}

export async function exportIRPFToDownloadSales(type) {
	return function(dispatch) {
		dispatch({
			type: EXPORT_IRPF_REQUESTED
		});

		return exportIRPFToDownloadOffer(type)
			.then(data => {
				dispatch({
					type: EXPORT_IRPF_FINISH
				});
			})
			.catch(() => {
				dispatch({
					type: OPEN_CLOSE_GENERAL_ALERT,
					payload: {
						isIRPFFetching: false,
						generalAlertOpen: true,
						generalAlertMsg:
							"Você não possui nenhum pagamento efetuado em " +
							(new Date().getUTCFullYear() - 1) +
							"."
					}
				});
			});
	};
}

export function filterSalesByStatusTab(status) {
	return function(dispatch) {
		return [
			dispatch(getAllSales(obj)),
			dispatch({ type: SALES_TAB_STATUS_FILTERED, payload: obj })
		];
	};
}

export function handleChangeFilterStatements(currentStatements, newStatements, instantSearch) {
	return function(dispatch) {
		const mergedStatements = Object.assign({}, currentStatements, newStatements);

		if (instantSearch) {
			dispatch(getAllSales(mergedStatements));
		}

		dispatch({
			type: SALES_FILTERED,
			payload: {
				filters: mergedStatements
			}
		});
	};
}

export function handleResetFilterAndExport() {
	return {
		type: SALES_FILTERED,
		payload: {
			filters: {
				dateMethod: {
					label: "Selecionar"
				},
				status: 0,
				periodType: 0,
				idsFidelity: [],
				checkboxStatus: {
					canceled: true,
					toReceive: true,
					received: true,
					others: true
				}
			}
		}
	};
}

export function handleSearch(searched) {
	return function(dispatch) {
		getUserSaleByTicket(getUserToken(), searched)
			.then(success => {
				dispatch({
					type: SALES_SEARCH_RECEIVED,
					payload: {
						request: success,
						searched
					}
				});
			})
			.catch(error => {
				if (error.response.status === 404) {
					dispatch({
						type: SALES_SEARCH_NOT_FOUND,
						payload: true
					});
				} else {
					dispatch({
						type: SALES_FIND_ERROR,
						payload: error
					});
				}
			});
	};
}

export function searchIsLoading(value) {
	return {
		type: DATA_SEARCH_WAS_REQUESTED,
		payload: value
	};
}

export function changeViewMode(mode) {
	return {
		type: SALES_VIEW_MODE,
		payload: mode
	};
}

export function openOrCloseFilterModal(isOpened) {
	return {
		type: SALES_OPEN_CLOSE_FILTER_MODAL,
		payload: isOpened
	};
}

export function openOrCloseExportModal(isOpened) {
	return {
		type: SALES_OPEN_CLOSE_EXPORT_MODAL,
		payload: isOpened
	};
}

export function openOrCloseExportFinishedModal(isOpened) {
	return {
		type: EXPORT_FINISHED_MODAL,
		payload: isOpened
	};
}

export function openOrCloseGeneralAlert(isOpened, msg = "") {
	return {
		type: OPEN_CLOSE_GENERAL_ALERT,
		payload: {
			generalAlertOpen: isOpened,
			generalAlertMsg: msg
		}
	};
}

export function openOrCloseSearchMobile(isOpened) {
	return {
		type: SALES_OPEN_CLOSE_SEARCH_MOBILE,
		payload: isOpened
	};
}

export function openOrCloseSearchDesktop(isOpened) {
	return {
		type: SALES_SEARCH_IS_OPEN,
		payload: isOpened
	};
}

export function handleErrors(currentErrors, newErrors) {
	const mergedErrors = Object.assign({}, currentErrors, newErrors);

	return {
		type: SALES_HAS_FIELD_ERRORS,
		payload: mergedErrors
	};
}
